import { InputField } from "components/InputField/Input";
import { CommonButton } from "components/Buttons/Buttons";
import { BiMinus, BiPlus } from "react-icons/bi";
import useItemDropdown from "./useItemDropdown";
import { dropdownFunction } from "utilities/dropdownFunction";
import { toast } from "react-toastify";


const useProductDataTable = (formik, setDeleteProductID, setShowDeleteProductModal) => {
    const addProductOnChange = (e, i, fieldName) => {

        if(e?.value > formik.values.sale_items[i]?.item.remain_quantity){
            toast.warning("Sale quantity must be less than remaining quantity.")
            formik.setFieldValue(`sale_items[${i}].${fieldName}`, 0);
        }else{
            formik.setFieldValue(`sale_items[${i}].${fieldName}`, e?.value || e?.target?.value);
        }
    };

    const { productDropdown, setProductDropdown, stockList} = useItemDropdown();

    const modalTableColumns = [
        {
            field: "item",
            header: "Item",
            sortableBody: (value, event) => (
                <div className="w-50">
                    <InputField
                        id="item"
                        name="item"
                        autoFilteredValue={productDropdown}
                        autoCompleteMethod={(event) => dropdownFunction(event, setProductDropdown, stockList)}
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "item")}
                        value={formik.values.sale_items[event.rowIndex]?.item}
                        type="select"
                        label="Select Item"
                        width="full"
                        autoCompleteFieldName="name"
                        required={true}
                        errors={formik.errors.sale_items?.[event.rowIndex]?.item?.id}
                    />
                </div>
            ),
        },
        {
            field: "unit",
            header: "Unit",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="unit"
                        name="unit"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "unit")}
                        value={formik.values.sale_items[event.rowIndex]?.item?.uom}
                        type="text"
                        width="full"
                        autoCompleteFieldName="unit"
                        disabled
                        messagePosition='bottom'
                        errors={formik.errors.sale_items?.[event.rowIndex]?.item?.uom}
                    />
                </div>
            ),
        },
        {
            field: "remain_quantity",
            header: "Remain Quantity",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="remain_quantity"
                        name="remain_quantity"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "remain_quantity")}
                        value={formik.values.sale_items[event.rowIndex]?.item?.remain_quantity}
                        type="text"
                        width="full"
                        autoCompleteFieldName="remain_quantity"
                        required={false}
                        disabled
                        errors={formik.errors.sale_items?.[event.rowIndex]?.item?.remain_quantity}
                    />
                </div>
            ),
        },
        {
            field: "rate",
            header: "Rate",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="rate"
                        name="rate"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "rate")}
                        value={formik.values.sale_items[event.rowIndex]?.item?.rate}
                        type="numbers"
                        width="full"
                        autoCompleteFieldName="rate"
                        required={false}
                        disabled
                        // errors={formik.values.sale_items[event.rowIndex]?.item?.rate}
                    />
                </div>
            ),
        },
        {
            field: "sale_quantity",
            header: "Sale Quantity",
            sortableBody: (value, event) => (
                <div className="w-25">
                    <InputField 
                        id="sale_quantity"
                        name="sale_quantity"
                        onChange={(e) => addProductOnChange(e, event.rowIndex, "sale_quantity")}
                        value={formik.values.sale_items[event.rowIndex]?.sale_quantity}
                        type="numbers"
                        width="full"
                        autoCompleteFieldName="sale_quantity"
                        required={false}
                        messagePosition = 'toast'
                        errors={formik.errors.sale_items?.[event.rowIndex]?.sale_quantity}
                    />
                </div>
            ),
        },
        {
            field: "total_price_per_item",
            header: "Total price",
            sortableBody: (value, event) => (
                <div className="w-25" style={{"textAlign": "center"}}>
                    <span style={{"color": "#203225"}}>
                        {((parseInt(formik.values.sale_items[event.rowIndex]?.sale_quantity) * parseFloat(formik.values.sale_items[event.rowIndex]?.item?.rate)) || 0).toFixed(3)}
                    </span>
                </div>
            ),
        },
    ]

    const deleteRequisitionItems = (rowData) => {
        const {id, requisition} = rowData;
        setDeleteProductID({id, requisition})
        setShowDeleteProductModal(true)
    }

    const modalTableActionButton = (rowData, {rowIndex}) => {
        const handleOnFieldIncrement = () => {
            const joinData = formik.values.sale_items.concat({
                fieldId: rowIndex + 1,
                item: "",
                remain_quantity: "",
                rate: "",
                sale_quantity: "",
                total_price_per_item: "",
            });
            formik.setFieldValue("sale_items", joinData)
        };

        const handleOnFieldDecrement = (i) => {
            if(rowData.id > 0){
                return deleteRequisitionItems(rowData)
            }
            const removeData = [...formik.values.sale_items];
            removeData.splice(rowIndex, 1);
            formik.setFieldValue("sale_items", removeData);
        };

        return (
            <>
                <div className="flex items-center justify-center">
                    {
                        formik.values.sale_items.length - 1 === rowIndex ? (
                            <>
                                <CommonButton 
                                    icon={<BiPlus className="text-green-700 text-2xl" />}
                                    className="p-button-rounded p-mr-2 action-button-green"
                                    title=""
                                    type="button"
                                    onClick={handleOnFieldIncrement}
                                />
                                {formik.values.sale_items.length !== 1 && 
                                <CommonButton 
                                    icon={<BiMinus className="text-red-700 text-2xl" />} 
                                    className="p-button-rounded p-mr-2 action-button-red" 
                                    title="" 
                                    type="button" 
                                    onClick={handleOnFieldDecrement} 
                                />}
                            </>
                        ) : 
                        (
                            <>
                                <CommonButton 
                                    icon={<BiMinus className="text-red-700 text-2xl" />} 
                                    className="p-button-rounded p-mr-2 action-button-red" 
                                    title="" 
                                    type="button" 
                                    onClick={handleOnFieldDecrement} 
                                />
                            </>
                        )
                    }
                </div>
            </>
        )
    }

    return {
        modalTableColumns,
        modalTableActionButton,
    }
}

export default useProductDataTable